import { useNavigate } from 'react-router-dom';
import AuthCard, {
  authButtonClass,
  authInputClass,
  authLabelClass,
} from '../components/AuthCard';
import { login } from '../store/authSlice';
import loadingGif from '/asset/loading.gif';
import { LoginCredentials } from '../interfaces';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import EyeIcon from '/asset/eye.svg';
import ClosedEyeIcon from '/asset/closed-eye.svg';
import { clearError } from '../store/purchaseSlice';
import purchaseService from '../services/purchaseService';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [showPassword, setShowPassword] = useState(false);
  const auth_status = useSelector((state: RootState) => state.auth.status);
  const { routesPrefix, loginFrom } = useSelector(
    (state: RootState) => state.setup
  );

  const [loginCredentials, setLoginCredentials] = useState<LoginCredentials>({
    userName: '',
    password: '',
  });
  const purchaseData = useSelector(
    (state: RootState) => state.purchase.purchase
  );

  const updateLoginCredentials = (name: string, value: string) => {
    setLoginCredentials({ ...loginCredentials, [name]: value });
  };

  const handleLogin = () => {
    dispatch(login(loginCredentials)).then((response) => {
      if (
        response?.payload?.accessToken &&
        purchaseData?.purchases &&
        purchaseData.purchases.length > 0
      ) {
        purchaseService.transferGuestCart();
        if (loginFrom === 'bnplcheckout') {
          navigate(`${routesPrefix}cart?checkout=bnpl`);
        } else if (loginFrom === 'checkout') {
          navigate(`${routesPrefix}cart`);
        } else {
          navigate(`${routesPrefix}`);
        }
      }
      dispatch(clearError());
    });
  };

  return (
    <AuthCard
      title="Welcome back"
      subtitle="Sign in to your account to continue"
    >
      {/* Email */}
      <div className="mb-[22px]">
        <label className={authLabelClass}>Email Address</label>
        <input
          className={authInputClass}
          placeholder="you@example.com"
          type="text"
          onChange={(e) => updateLoginCredentials('userName', e.target.value)}
        />
      </div>

      {/* Password */}
      <div>
        <label className={authLabelClass}>Password</label>
        <div className="relative">
          <input
            className={`${authInputClass} pr-[48px]`}
            placeholder="Your password"
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => updateLoginCredentials('password', e.target.value)}
          />
          <img
            src={!showPassword ? ClosedEyeIcon : EyeIcon}
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-[16px] top-1/2 -translate-y-1/2 cursor-pointer w-[20px] h-[20px] object-contain opacity-60 hover:opacity-90 transition-opacity"
          />
        </div>
      </div>

      <div className="flex justify-end mt-[16px]">
        <span
          className="font-dmsans text-[14px] text-gray-500 cursor-pointer hover:text-gray-700 hover:underline"
          onClick={() => navigate(`${routesPrefix}resetpassword`)}
        >
          Forgot password?
        </span>
      </div>

      {/* Login Button */}
      {auth_status !== 'loading' ? (
        <button
          className={`${authButtonClass} mt-[28px] bg-[#1E6DB4] hover:bg-[#195d9a] active:bg-[#154f83] text-white cursor-pointer`}
          onClick={handleLogin}
        >
          Log In
        </button>
      ) : (
        <div className="flex justify-center items-center gap-2 h-[52px] mt-[28px]">
          <img src={loadingGif} className="w-[32px] h-[20px] object-cover" />
          <span className="font-dmsans text-[13px] text-gray-500">
            Loading...
          </span>
        </div>
      )}

      {/* Sign up link */}
      <div className="mt-[24px] text-center font-dmsans text-[14px] text-gray-500">
        Don't have an account?{' '}
        <span
          className="text-[#1E6DB4] cursor-pointer hover:underline font-medium"
          onClick={() => navigate(`${routesPrefix}signup`)}
        >
          Create one
        </span>
      </div>
    </AuthCard>
  );
}
